import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../variables';

export const IconButtonWrapper = styled.div`
    position: relative;
    display: inline-flex;
`;

export const IconButton = styled.button<{ disabled?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    border: ${Variables.Borders.regular};
    background-color: ${Variables.Colors.white};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    transition: ${Variables.transition};
    outline: none;
    padding: 0;

    &:hover {
        background-color: ${props => (props.disabled ? Variables.Colors.white : Variables.Colors.n15_24)};
    }

    &:active {
        background-color: ${props => (props.disabled ? Variables.Colors.white : Variables.Colors.n15_48)};
    }

    &:disabled {
        border-color: ${Variables.Colors.nx8};
        background-color: ${Variables.Colors.nx4};
    }
`;

export const CountBadge = styled.div`
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Variables.Colors.b500};
    color: ${Variables.Colors.white};
    border-radius: 9px;
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1;
    pointer-events: none;
`;

export const ButtonIcon = styled(Icon)<{ color?: string }>`
    width: 20px;
    height: 20px;
    path {
        fill: ${props => props.color || Variables.Colors.n70};
    }
`;

export const MenuContainer = styled.div`
    position: relative;
    min-width: 200px;
    padding: 8px 0;
    max-height: 300px;
    overflow-y: auto;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: ${Variables.Colors.n15};
    }
    
    &::-webkit-scrollbar-thumb {
        background: ${Variables.Colors.n30};
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: ${Variables.Colors.n50};
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${Variables.Swatches.AlphaLightGray80};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    backdrop-filter: blur(1px);
`;

export const Spinner = styled.div`
    width: 24px;
    height: 24px;
    border: 3px solid ${Variables.Swatches.Gray3};
    border-top-color: ${Variables.Swatches.Blue6};
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
    
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

export const MenuItem = styled.div<{ selected?: boolean; disabled?: boolean; hasIcon?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 42px 8px ${props => (props.hasIcon ? '16px' : '16px')};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    user-select: none;
    white-space: nowrap;
    color: ${props => (props.selected ? Variables.Colors.b300 : Variables.Colors.n70)};
    font-size: 16px;
    font-weight: ${props => (props.selected ? '500' : 'normal')};

    &:hover {
        background-color: ${props => (props.disabled ? 'transparent' : Variables.Colors.n15_24)};
    }
`;

export const MenuItemIcon = styled(Icon)<{ color?: string }>`
    width: 20px;
    height: 20px;
    margin-right: 12px;
    flex-shrink: 0;
    path {
        fill: ${props => props.color || Variables.Colors.n15};
    }
`;

export const MenuItemLabel = styled.span`
    flex: 1;
`;

export const SelectedIcon = styled(Icon)`
    position: absolute;
    right: 16px;
    width: 18px;
    height: 18px;
    path {
        fill: ${Variables.Colors.b500};
    }
`;

export const LoadingMessage = styled.div`
    padding: 16px;
    text-align: center;
    color: ${Variables.Colors.n50};
    font-size: 14px;
`;

export const EmptyMessage = styled.div`
    padding: 16px;
    text-align: center;
    color: ${Variables.Colors.n50};
    font-size: 14px;
`;
